import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseManningVesselApi = AiseaApiFactory.get("enterpriseManningVessel");
const enterpriseCrewRoleApi = AiseaApiFactory.get("enterpriseCrewRole");

export default {
  async fetchAllManningVessels({ commit }) {
    let res = await enterpriseManningVesselApi.search({ page: 0, size: 999, });
    commit("SET_MANNING_VESSELS", res.data.manning_vessels);
  },

  async fetchAllCrewRoles({ commit }) {
    let res = await enterpriseCrewRoleApi.search();
    commit("SET_CREW_ROLES", res.data.roles);
  },


};
